import { render } from "./IconTurnSharpRightAlt.vue?vue&type=template&id=5b40087e"
import script from "./IconTurnSharpRightAlt.vue?vue&type=script&lang=js"
export * from "./IconTurnSharpRightAlt.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__